export function normalizeCreatorId(component: Record<string, unknown> | null | undefined): string {
    const a = component?.createdBy
    const b = component?._createdBy
    if (a != null && String(a).trim() !== "") return String(a).trim()
    if (b != null && String(b).trim() !== "") return String(b).trim()
    return ""
}

export function normalizeCollectionOwnerId(component: Record<string, unknown> | null | undefined): string {
    const ownersRaw = component?.owners
    const ownersObj = ownersRaw && typeof ownersRaw === "object" ? (ownersRaw as Record<string, unknown>) : null
    const explicit = component?.owner ?? component?.user ?? ownersObj?.user
    if (explicit != null && String(explicit).trim() !== "") {
        return String(explicit).trim()
    }
    return normalizeCreatorId(component)
}
